import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../../app/store"

interface LoaderState {
  loading: boolean | null
  forcedLoading: boolean | null
  forcedTurnOff: boolean | null
}

const initialState: LoaderState = {
  loading: null,
  forcedLoading: null,
  forcedTurnOff: null,
}

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setForcedLoading: (state, action: PayloadAction<boolean>) => {
      state.forcedLoading = action.payload
    },
    setForcedTurnOff: (state, action: PayloadAction<boolean>) => {
      state.forcedTurnOff = action.payload
    },
  },
})

export const { setLoading, setForcedLoading, setForcedTurnOff } =
  loaderSlice.actions

export const selectLoader = (state: RootState) => state.loader.loading

export default loaderSlice.reducer
